import React from "react";
import {GrantFormOneSpanish} from "./GrantFormOneSpanish";

export const ContactSectionFormOneSpanish = ({className = ''}) => {

  return (
    <div >
      <div className="form-container">
        <GrantFormOneSpanish />
      </div>
    </div>

  )
}